import React from 'react';
import { useLocation } from 'react-router-dom';
import { isInDevelopment } from '../config/serviceStatus';

const PageWrapper = ({ children }) => {
  const location = useLocation();
  const isDev = isInDevelopment(location.pathname);

  if (isDev) {
    return (
      <div className="opacity-50 grayscale">
        {children}
      </div>
    );
  }

  return <>{children}</>;
};

export default PageWrapper;
